export default "__VITE_ASSET___Dt7t5Nr__"